<template lang="pug">
.distribute-picture-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="submit" @cancel="cancel")
    div(slot="modal-title")
      span {{ message }}

    .default-modal-body.register-body
      .d-flex.flex-column
        FormCheck(v-model="sendMessage" key-name="配信設定" name="sendMessage" label="依頼者にメッセージを送信する")
      .d-flex.flex-column(v-if="sendMessage")
        FormTextarea(v-model="text" name="text" key-name="本文" placeholder="本文"
          :maxlength="1000" :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }" required)

    .distribute-picture-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      .d-flex.flex-column.flex-fill
        .buttons
          ValidationAlert(v-model="showValidationAlert")
          .m-0.d-flex.justify-content-end
            button.btn.modal-ok-btn.mr-2(type="button" @click="ok()") OK
            button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";

@Component({
  components: {
    FormTextarea,
    FormCheck,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class DistributePictureModal extends Vue {
  /** 表示するメッセージ */
  message: string = "";

  /** 依頼者にメッセージを送信するかどうか */
  sendMessage: boolean = false;
  /** 本文 */
  text: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  public show(message: string, receiveDatetime: number, residentName: string): void {
    this.message = message;
    this.sendMessage = false;
    const formatedDateString: string = this.$dateUtil.convertNumberToString(receiveDatetime, "yyyy年mm月dd日");
    const weekName: string = this.$dateUtil.getWeekName(this.$dateUtil.convertNumberToDate(receiveDatetime), "ja");
    const text: string = `${formatedDateString}（${weekName}）に送付いただいた写真を${residentName}様にお渡しいたしました。`;
    this.text = text;
    this.showValidationAlert = false;
    this.$validator.errors.clear();

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }
  }

  public hide(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.hide();
    }
  }

  public cancel(): void {
    this.showValidationAlert = false;
  }

  public async submit(modalEvent: any): Promise<void> {
    // 最初の await の前に同期的に自動クローズを防止する
    modalEvent.preventDefault();

    if (this.sendMessage) {
      // メッセージ送信にチェックがある場合のみ、必須入力等のバリデーションを行う
      const validationResult: boolean = await this.$validator.validateAll();
      if (!validationResult) {
        this.showValidationAlert = true;
        return;
      }
    }

    this.showValidationAlert = false;
    this.$emit("submit", {
      sendMessage: this.sendMessage,
      text: this.sendMessage ? this.text : ""
    });
  }
}
</script>

<style lang="scss" scoped>
.register-body {
  ::v-deep .register-group {
    margin: 0 0 1rem 0 !important;
  }
}
</style>
